import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import Icon from '../../../components/AppIcon';

const TabNavigation = ({ contractId }) => {
  const location = useLocation();
  
  const tabs = [
    {
      id: 'general',
      label: 'General Info',
      icon: 'FileText',
      path: '/contract-details',
      description: 'Basic contract information and terms'
    },
    {
      id: 'milestones',
      label: 'Milestones',
      icon: 'Calendar',
      path: '/milestone-management',
      description: 'Project milestones and deadlines',
      badge: 3
    },
    {
      id: 'signatures',
      label: 'Signatures',
      icon: 'PenTool',
      path: '/contract-details?tab=signatures',
      description: 'Signature status and management',
      badge: 2
    },
    {
      id: 'history',
      label: 'History',
      icon: 'Clock',
      path: '/contract-details?tab=history',
      description: 'Contract change history and audit trail'
    },
    {
      id: 'attachments',
      label: 'Attachments',
      icon: 'Paperclip',
      path: '/document-management',
      description: 'Contract documents and files',
      badge: 8
    },
    {
      id: 'jurisdiction',
      label: 'Jurisdiction',
      icon: 'MapPin',
      path: '/contract-details?tab=jurisdiction',
      description: 'Legal jurisdiction and governing law'
    }
  ];

  const getCurrentTab = () => {
    const urlParams = new URLSearchParams(location.search);
    const tabParam = urlParams?.get('tab');
    
    if (location.pathname === '/milestone-management') return 'milestones';
    if (location.pathname === '/document-management') return 'attachments';
    if (tabParam) return tabParam;
    return 'general';
  };

  const currentTab = getCurrentTab();

  return (
    <div className="bg-card border-b border-border">
      <div className="px-6">
        <nav className="flex space-x-8 overflow-x-auto">
          {tabs?.map((tab) => (
            <Link
              key={tab?.id}
              to={tab?.path}
              className={`flex items-center space-x-2 py-4 border-b-2 transition-legal-fast whitespace-nowrap ${
                currentTab === tab?.id
                  ? 'border-primary text-primary' :'border-transparent text-muted-foreground hover:text-foreground hover:border-border'
              }`}
              title={tab?.description}
            >
              <Icon name={tab?.icon} size={16} />
              <span className="text-sm font-medium">{tab?.label}</span>
              {tab?.badge && (
                <span className="bg-primary text-primary-foreground text-xs px-2 py-0.5 rounded-full">
                  {tab?.badge}
                </span>
              )}
            </Link>
          ))}
        </nav>
      </div>
    </div>
  );
};

export default TabNavigation;